import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchTodos, createTodo, deleteTodo } from '../api/todosApi';
import { postLogout } from '../api/loginApi';

export function Todos() {
  const navigate = useNavigate();
  const [todos, setTodos] = useState([]);
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchTodos().then((data) => {
      if (data.success) {
        setTodos(data.todos);
      }
    });
  }, []);

  const onSubmit = (e) => {
    e.preventDefault();
    if (!title.trim()) {
      setError('Title is required');
      return;
    }
    createTodo(title, description || undefined)
      .then((data) => {
        if (data.success) {
          setTodos((prev) => [data.todo, ...prev]);
          setTitle('');
          setDescription('');
          setError(null);
        }
      })
      .catch(() => setError('Failed to create todo'));
  };

  const onDelete = (e, id) => {
    e.stopPropagation();
    deleteTodo(id).then(() => {
      setTodos((prev) => prev.filter((t) => t.id !== id));
    });
  };

  const signOut = () => {
    postLogout().then(() => navigate('/login'));
  };

  return (
    <>
      <div
        className="row-flex"
        style={{ justifyContent: 'space-between', padding: '0 1rem' }}
      >
        <h2>My Todo Lists</h2>
        <button type="button" onClick={signOut}>
          Sign out
        </button>
      </div>

      <div className="column-flex align-center">
        <form onSubmit={onSubmit} className="column-flex align-center">
          <label>
            Title:
            <input
              type="text"
              value={title}
              onInput={(e) => setTitle(e.target.value)}
            />
          </label>
          <br />
          <label>
            Description:
            <input
              type="text"
              value={description}
              onInput={(e) => setDescription(e.target.value)}
            />
          </label>
          <br />
          <button type="submit">Add todo</button>
          {error && <p style={{ color: 'red' }}>{error}</p>}
        </form>
      </div>

      <div className="column-flex align-center" style={{ marginTop: '1rem' }}>
        {todos.length === 0 && <p>No todos yet.</p>}
        {todos.map((todo) => (
          <div
            key={todo.id}
            className="row-flex"
            style={{
              justifyContent: 'space-between',
              width: '400px',
              cursor: 'pointer',
              padding: '0.5rem',
              borderBottom: '1px solid #ccc',
            }}
            onClick={() => navigate(`/todos/${todo.id}`)}
          >
            <span
              style={{
                textDecoration: todo.completed ? 'line-through' : 'none',
              }}
            >
              {todo.title}
            </span>
            <button type="button" onClick={(e) => onDelete(e, todo.id)}>
              Delete
            </button>
          </div>
        ))}
      </div>
    </>
  );
}
